import { loopBackApi } from '../../models/LoopBack/Api/LoopBackApi';
import { createAction } from '../../models/redux/CreateAction';
import * as types from '../Table/types';

export const initState = (stateKey: number | string, filters: {}) =>
  createAction(types.INIT_STATE, { stateKey, filters });

export const fetchTable = (stateKey: number | string, endPoint: string, filters: {} = {}) => {
  return createAction(types.FETCH_TABLE, { stateKey, endPoint, filters });
};

export const fetchCount = (stateKey: number | string, endPoint: string, filters: {} = {}) =>
  createAction(
    types.FETCH_COUNT,
    loopBackApi()
      .get(endPoint, filters)
      .then(res => ({ stateKey, data: res.data }))
      .catch(err => ({ stateKey, data: null }))
  );

export const setPagination = (stateKey: number | string, pagination: {}) =>
  createAction(types.SET_PAGINATION, { stateKey, data: pagination });

export const setLoading = (stateKey: number | string, loading: boolean) =>
  createAction(types.SET_LOADING, { stateKey, loading });
